import { useModalStore } from '@/shared/lib';
import { UserProfileInfoModal } from '../ui';

type OpenUserProfileInfoDialogParams = {
  onBack: () => void;
  ewalletAccNum: string | undefined;
};

export function useUserProfileInfoModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openUserProfileInfoDialog = ({
    onBack,
    ewalletAccNum,
  }: OpenUserProfileInfoDialogParams) => {
    showDialogComponent({
      component: (
        <UserProfileInfoModal onBack={onBack} ewalletAccNum={ewalletAccNum} />
      ),
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openUserProfileInfoDialog };
}
